import BootStrapTabs from '../../common/BootStrap/BootStrapTabs';

const BannerTab = ({ setExposureLocation, exposureLocation }) => {
    const tabList = [
        {
            title: '시놀/시럽 팝업',
            key: 1,
        },
        {
            title: '시놀 홈 띠',
            key: 2,
        },
        {
            title: '시럽 관심 띠',
            key: 3,
        },
        {
            title: '시놀/시럽 공동 구매',
            key: 6,
        },
    ];

    return <BootStrapTabs tabList={tabList} setValue={setExposureLocation} defaultKey={exposureLocation}></BootStrapTabs>;
};

export default BannerTab;
